import choiceadvantage from 'img/pms/choice-advantage.png'
import clock from 'img/pms/clock-pms.png'
import cloudbeds from 'img/pms/cloudbeds.png'
import hotelkey from 'img/pms/hotelkey.png'
import infor from 'img/pms/infor.png'
import jonaschorum from 'img/pms/jonaschorum.png'
import maestro from 'img/pms/maestro.png'
import marriottgxp from 'img/pms/marriottgxp.png'
import mews from 'img/pms/mews.png'
import ohip from 'img/pms/ohip.png'
import resnexus from 'img/pms/resnexus.png'
import roomkey from 'img/pms/roomkey.png'
import skytouch from 'img/pms/skytouch.png'
import synxis from 'img/pms/synxis.png'
import visualmatrix from 'img/pms/visualmatrix.png'
import webrezpro from 'img/pms/webrezpro.png'

import styles from './PMSLogo.module.scss'

const logos = {
  webrezpro,
  choiceadvantage,
  skytouch,
  visualmatrix,
  marriottgxp,
  roomkey,
  resnexus,
  jonaschorum,
  ohip,
  clock,
  maestro,
  infor,
  cloudbeds,
  synxis,
  mews,
  hotelkey
}

const PMSLogo = ({ pms }) => {
  if (logos[pms]) {
    return <img src={logos[pms]} alt={`${pms} logo`} />
  } else {
    return <div className={styles.textLogo}>{pms.toUpperCase()}</div>
  }
}

export default PMSLogo
